module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/f64590d85fc77d74e5b1e9171726bda7.png";